module.exports = __webpack_public_path__ + "media/images/captive_portal/Guest-data-689fb0298af1c6863f5f8c50487bfde0.svg";